import { FC, useEffect, useState } from "react";
import parse from "html-react-parser";
import { Container } from 'react-bootstrap';
import { Tabs, Tab, TabScreen } from 'react-tabs-scrollable'

import { NML_PAGE } from "../../../interfaces/Static/routing_paths";
import Heading from "../../Shared/Common/Heading";
import { Anchor } from "../../Shared/Common/Anchor";
import SimpleImage from "../../Shared/Media/SimpleImage";
import PillsTab from "../../Shared/Common/PillsTab";
import ExploreOtherArea from "../../Shared/RegionalPages/ExploreOtherArea";

import TimetoApply from "../../Shared/RegionalPages/TimetoApply";
import { NML_KEY } from "../../../utils/_active_regions";
import { NML_SUB_PAGES } from "../../../Config/Static/ProgramDetail/Nml";
import NmlCard from "../../Shared/Common/Card/NmlCard";
import { FormattedMessage } from "react-intl";
import TrainingDevelopment from "./_tranining_and_development";
import Career from "./_career";
import RecruitingInformation from "./_recruiting_information";
interface Props {
    pageId: string;
}

const NmlSubPage: FC<Props> = ({ pageId }) => {
    const pageData = NML_SUB_PAGES.find(x => x.slug === pageId);
    const [key, setKey] = useState<any>(0);

    const onTabClick = (e: any, index: any) => {
        setKey(index)
    }
    useEffect(() => {
        setKey(0);
    }, [pageId]);

    if (!pageData)
        return null;

    return (
        <>
            <section className="banner americas inner">
                <SimpleImage src={pageData.banner_src} />
                <div className="container">
                    <div className="banner-caption">
                        <h1><FormattedMessage id={pageData.banner_title} /></h1>
                        <div className="sub-text"><FormattedMessage id={pageData.banner_description} /></div>
                    </div>
                </div>
            </section>
            <Container className="mb-3 pb-3">
                <div className="breadcrumb-container">
                    <Anchor href={NML_PAGE}>
                        <FormattedMessage id={"page.common.home"} />
                    </Anchor>
                    <Anchor href="#">
                        <FormattedMessage id={"page.common.programs"} />: <FormattedMessage id={pageData.name} />
                    </Anchor>
                </div>
                {pageData.isRecruitingRequired && <RecruitingInformation />}
                {pageData.isCareerRequired && <Career />}
                {pageData.isTrainingDevelopmentRequired && <TrainingDevelopment />}
                <div className="research-area">
                    <Heading type="section-heading">
                        <FormattedMessage id={pageData.swapPageTitle || pageData.name} />
                    </Heading>
                    {
                        pageData.description &&
                        <p><FormattedMessage id={pageData.description} /></p>
                    }

                </div>
                <div className="department-area">
                    {
                        pageData.nmlItems && pageData.nmlItems.length > 0 && (
                            <div className='tab-content'>
                                <NmlCard items={pageData.nmlItems} />
                            </div>
                        )
                    }
                    {
                        pageData.locations && pageData.locations.length > 0 && (
                            <PillsTab translation={true} activeKey={pageId} slug={pageData.slug} locations={pageData.locations} />
                        )
                    }
                </div>
                <ExploreOtherArea pageId={pageId} region={NML_KEY} />
            </Container>
            <TimetoApply url={pageData.work_day_link} href_jp={pageData.work_day_link_jp} />
        </>
    );
};
export default NmlSubPage;
